import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { USE_THIS_PAYMENT_DESKTOP } from 'constants/checkoutButtons';
import { CHECKOUT_STEP_MAP, NEW_PAYMENT_STEP } from 'constants/checkoutFlow';

import ContentBox from 'components/checkout/caap/ContentBox';
import DesktopOnly from 'components/checkout/caap/DesktopOnly';
import GiftCardContainer from 'components/checkout/caap/GiftCardContainer';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/payment/paymentlist/addPaymentAndGiftCardDesktop.scss';

const AddPaymentAndGiftCardDesktop = (componentParams, { testId }) => {
  const {
    canUseThisPayment,
    constraintViolations,
    giftCards = {},
    isFetchingCheckoutData,
    onGiftCardChange,
    onGiftCardVerify,
    onToggleGiftCardModalClick,
    onUseThisPaymentClick,
    purchaseId
  } = componentParams;

  return (
    <DesktopOnly>
      <Row>
        <div className={css.useThisPaymentButtonContainer}>
          <button
            className={css.checkoutPrimaryButton}
            disabled={!canUseThisPayment || isFetchingCheckoutData}
            id={USE_THIS_PAYMENT_DESKTOP}
            onClick={onUseThisPaymentClick}
            type="button">
            Use this payment method
          </button>
        </div>
      </Row>
      <Row>
        <div>
          <RowSpan span="5">
            <ContentBox isNonRadio={true} isLast={true} contentKey="paymentListAddNewPayment">
              <h4 className={css.addPaymentTitle}>Add a new payment method</h4>
              <Link
                data-te="TE_CHECKOUT_PL_GO_TO_ADD_NEW"
                to={`${CHECKOUT_STEP_MAP[NEW_PAYMENT_STEP]}?referrer=pay&pid=${purchaseId}`}>
                <button type="button" className={css.checkoutSecondaryButton} data-test-id={testId('enterNewCard')}>Add a debit or credit card</button>
              </Link>
            </ContentBox>
          </RowSpan>

          <RowSpan span="7">
            <ContentBox isNonRadio={true} isLast={true} contentKey="paymentListGcDesktop">
              <GiftCardContainer
                code={giftCards.code || ''}
                constraintViolations={constraintViolations}
                isFetchingCheckoutData={isFetchingCheckoutData}
                onGiftCardChange={onGiftCardChange}
                onGiftCardVerify={onGiftCardVerify}
                onToggleGiftCardModalClick={onToggleGiftCardModalClick}
                showGiftCardModal={giftCards.showModal}
              />
            </ContentBox>
          </RowSpan>
        </div>
      </Row>
    </DesktopOnly>
  );
};

AddPaymentAndGiftCardDesktop.contextTypes = {
  testId: PropTypes.func
};

export default AddPaymentAndGiftCardDesktop;
